import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService, SearchParams } from './api.service';
import { CrmConfiguration } from '../configuration/crm-configuration/interfaces/crm-configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class CrmConfigurationService {

  CrmConfigurations: BehaviorSubject<any> = new BehaviorSubject(null);

  private _crmConfigurationsProcessing = false;

  // endpoints
  private _crmConfigurationsEp = `${this._apiSvc.endpoints.crm}/api/CrmConfiguration`;

  constructor(
    private _apiSvc: ApiService
  ) { }

    /**
   * Get crm configurations and return observable
   */
  getCrmConfigurationsAsync( searchParams?: SearchParams): Observable<any> {
    let params = null;
    if(!searchParams) {
      params = {
        sort: 'StoreRefCode-asc'
      };
    }
    else {
      params = searchParams;
    }
    return this._apiSvc.search(this._crmConfigurationsEp, params)
  }

  /**
   * Get crm configurations
   */
  getCrmConfigurations(refresh: boolean = false): void {

    if (this._crmConfigurationsProcessing || (this.CrmConfigurations.value && !refresh)) return;

    this._crmConfigurationsProcessing = true;

    const params = {
      sort: 'StoreRefCode-asc'
    };

    this._apiSvc.search(this._crmConfigurationsEp, params)
      .subscribe((res: any) => {
        this._crmConfigurationsProcessing = false;
        this.CrmConfigurations.next(res.Data);
      }, () => {
        this._crmConfigurationsProcessing = false;
      });

  }

  /**
   * Get crm Configuration
   * @param crmConfigurationId 
   */
  getCrmConfiguration(crmConfigurationId: number): any {
    return this._apiSvc.get(`${this._crmConfigurationsEp}/${crmConfigurationId}`);
  }

  // Search Crm Configuration by store ref id
  searchCrmConfigurationByStoreRefId(storeRefId: number): any {
    const params = {
      Filter: `StoreRefId~eq~${storeRefId}`
    };
    return this._apiSvc.search(this._crmConfigurationsEp, params);
  }


    /**
   * Update crm configuration
   * @param crmConfigurationId 
   * @param values 
   * @returns 
   */
    update(crmConfigurationId: number, values: CrmConfiguration): any {
      return this._apiSvc.update(`${this._crmConfigurationsEp}/${crmConfigurationId}`, values);
    }
}
